import PropTypes from 'prop-types';
import React from 'react';

import useTranslation from '../../hooks/use_translation';
import SectionHeader from '../framework/sections/section-header';
import Trans from '../translation/trans';
import './statistics.scss';
import StatisticsCard from './statistics-card';

const Statistics = ({ statistics }) => {
	const { t } = useTranslation('component_statistics');

	const defaultStatisticsData = [
		{
			color: 'dark',
			disclaimer: <Trans i18nKey="t4" t={t} />,
			percentage: 56.6,
			text: t('t3'),
		},
		{
			color: 'white',
			disclaimer: t('t6'),
			percentage: 8.96,
			text: t('t5'),
		},
	];

	const statisticsData =
		statistics?.length > 0 ? statistics : defaultStatisticsData;

	return (
		<div className="container">
			<SectionHeader
				align="center"
				excerpt={t('t2')}
				headingType="h3"
				hideButton
				size="lg"
				title={t('t1')}
			/>

			<div className="row">
				{statisticsData.map((stat, index) => (
					<div className="col-lg-6 col-md-6 mb-4" key={index}>
						<StatisticsCard
							color={stat.color || 'dark'}
							disclaimer={stat.disclaimer}
							percentage={stat.percentage}
							text={stat.text}
						/>
					</div>
				))}
			</div>
		</div>
	);
};

Statistics.propTypes = {
	statistics: PropTypes.arrayOf(
		PropTypes.shape({
			color: PropTypes.string,
			disclaimer: PropTypes.string,
			percentage: PropTypes.string,
			text: PropTypes.string,
		}),
	),
};

export default Statistics;
